import * as React from 'react';
import { COLORS } from '../styles';
import ScreenSetsContainer from './ScreenSetsContainer';
import { InformationContainer, InformationContent, InformationHeader, InformationText, InformationImage } from './Information';

type AuthPageProps = {
  /** set this to 'false' to hide the left side illustration/information section */
  showInformationSection: boolean;
  /** true if 'sign-up' screen-set is showing, otherwise false.
   * The value can be set using 'onBeforeScreenLoad' in 'gigya.accounts.showScreenSet(...)' and checking the loaded screen-set */
  signUp: boolean;
  /** img src string for 'sign-up' placeholder image */
  signUpPlaceholderImage?: string;
  /** img src string for 'sign-in' placeholder image */
  signInPlaceholderImage?: string;
  /** img alt text string for 'sign-up' placeholder image */
  signUpPlaceholderImageAlt?: string;
  /** img alt text string for 'sign-in' placeholder image */
  signInPlaceholderImageAlt?: string;
  /** information header text string below 'sign-up' placeholder image */
  signUpInformationHeader?: string;
  /** information header text string below 'sign-in' placeholder image */
  signInInformationHeader?: string;
  /** information text string below 'sign-up' header text */
  signUpInformationText?: string;
  /** information text string below 'sign-in' header text */
  signInInformationText?: string;
  /** ID that will be given to the SAP CDC screen-sets container (must match 'containerID' in 'gigya.accounts.showScreenSet(...)'!) */
  screenSetsContainerId: string;
};

/**
 * The 'AuthPage' component consist of two containers: an 'Information' container on the left, and a 'ScreenSetsContainer' on the right.
 * The 'Information' container is optional and its contents depend on the context (sign-up or sign-in).
 * The 'ScreenSetsContainer' will contain the SAP CDC screen-sets.
 */
const AuthPage = ({
  showInformationSection,
  signUp,
  signUpPlaceholderImage,
  signInPlaceholderImage,
  signUpPlaceholderImageAlt,
  signInPlaceholderImageAlt,
  signUpInformationHeader,
  signInInformationHeader,
  signUpInformationText,
  signInInformationText,
  screenSetsContainerId,
}: AuthPageProps) => {
  return (
    <>
      {showInformationSection && (
        <InformationContainer color={signUp ? COLORS.accent1_20 : COLORS.primary_20}>
          <InformationContent>
            {(signUpPlaceholderImage || signInPlaceholderImage) && (
              <InformationImage src={signUp ? signUpPlaceholderImage : signInPlaceholderImage} alt={signUp ? signUpPlaceholderImageAlt : signInPlaceholderImageAlt} />
            )}
            {(signUpInformationHeader || signInInformationHeader) && <InformationHeader>{signUp ? signUpInformationHeader : signInInformationHeader}</InformationHeader>}
            {(signUpInformationText || signInInformationText) && <InformationText>{signUp ? signUpInformationText : signInInformationText}</InformationText>}
          </InformationContent>
        </InformationContainer>
      )}
      <ScreenSetsContainer id={screenSetsContainerId} centerContents={!showInformationSection} />
    </>
  );
};

export default AuthPage;
